module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adverts/adverts-edit/adverts-edit.component.css
// module id = ./src/app/components/adverts/adverts-edit/adverts-edit.component.css
// module chunks = main